import React, {useEffect, useState} from "react";
import {getUserCode} from "../../requests/AppSession";
import QRCode from "react-qr-code";
import {SquareSkeleton} from "./VTSkeletons";

export default function VTUserCode() {

    const [userCode, setUserCode] = React.useState("");
    const [isQRReader, setIsQRReader] = useState(true);

    useEffect(() => {
        getUserCode().then(theUserCode => {
            setUserCode(theUserCode);
        })
        return function cleanup() {

        };
    }, []);

    return (
        <div className="bg-gray-50 dark:bg-gray-800 px-4 py-10 sm:py-16">
            <div className="mx-auto w-full max-w-sm overflow-hidden rounded-2xl bg-white dark:bg-gray-800 shadow-sm ring-1 ring-pink-100">
                <div className="px-6 py-8 text-center">
                    <h3 className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-100">
                        Present to <span className="text-pink-500">Buy</span>
                    </h3>

                    {/* QR must stay pure black-on-white with quiet margin to scan reliably. */}
                    {userCode ?
                        <div
                            className="mx-auto mt-6 rounded-xl bg-white p-4 ring-1 ring-pink-100"
                            style={{maxWidth: 280, width: "100%"}}
                        >
                            {isQRReader && <QRCode
                                size={280}
                                style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                value={userCode}
                                viewBox={`0 0 256 256`}
                            />}
                        </div>
                        :
                        <SquareSkeleton size={280}/>
                    }

                    <p className="mt-6 text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
                        Your User Code
                    </p>
                    <div className="mt-2">
                        {userCode ?
                            <p className="inline-block rounded-lg bg-pink-50 dark:bg-pink-950/40 px-5 py-2 font-mono text-3xl font-bold tracking-[0.15em] text-gray-900 dark:text-pink-200 ring-1 ring-inset ring-pink-100 dark:ring-pink-800">
                                {userCode}
                            </p>
                            :
                            <p className="text-3xl font-bold text-gray-300">&middot;&middot;&middot;&middot;</p>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
